import { render } from "./CommentCol.vue?vue&type=template&id=7d82f996&scoped=true"
import script from "./CommentCol.vue?vue&type=script&lang=js"
export * from "./CommentCol.vue?vue&type=script&lang=js"

import "./CommentCol.vue?vue&type=style&index=0&id=7d82f996&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d82f996"]])

export default __exports__